import { useState } from "react";

import "./InvoiceExportPanel.css";

export default function InvoiceExportPanel({ onFetch }) {
  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!dateStart || !dateEnd) return;

    setLoading(true);
    try {
      await onFetch({
        date_start_inclusive: `${dateStart}T00:00:00`,
        date_end_exclusive: `${dateEnd}T00:00:00`,
        user_id: userEmail.trim() || null,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="invoice-export-panel" onSubmit={handleSubmit}>
      <fieldset className="invoice-export-panel__fieldset">
        <h1 className="invoice-export-panel__legend">Invoice export</h1>
        <p className="invoice-export-panel__description">
          Select the billing period and optionally filter by user email.
        </p>

        <div className="invoice-export-panel__row">
          <div className="invoice-export-field">
            <label htmlFor="invoice-date-start">Date start</label>
            <input
              id="invoice-date-start"
              type="date"
              required
              value={dateStart}
              onChange={(e) => setDateStart(e.target.value)}
            />
          </div>

          <div className="invoice-export-field">
            <label htmlFor="invoice-date-end">Date end</label>
            <input
              id="invoice-date-end"
              type="date"
              required
              value={dateEnd}
              onChange={(e) => setDateEnd(e.target.value)}
            />
          </div>

          <div className="invoice-export-field">
            <label htmlFor="invoice-user-email">User email</label>
            <input
              id="invoice-user-email"
              type="email"
              placeholder="Optional"
              value={userEmail}
              onChange={(e) => setUserEmail(e.target.value)}
            />
          </div>
        </div>

        <div className="invoice-export-panel__actions">
          <button type="submit" className="get-invoices-button" disabled={loading}>
            {loading ? "Loading…" : "Get invoices"}
          </button>
        </div>
      </fieldset>
    </form>
  );
}
